import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'ebb-portal-dialog-confirm-submission',
    templateUrl: './dialog-confirm-submission.component.html',
    standalone: false
})
export class DialogConfirmSubmissionComponent implements OnInit {

  wasResubmit: boolean;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmSubmissionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.wasResubmit = data.wasResubmit ? true : false;
  }

  ngOnInit() {
  }

  onClickClose(): void {
    this.dialogRef.close();
  }

}
